module.exports = __webpack_public_path__ + "files/572fb2a83f425358645864fd7be5412c.gif";